<template>
    <form @submit.prevent="onSubmit" class="form-horizontal form-material">
        <div class="card text-white bg-danger" v-if="showFailureMessage">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Validation Errors</h4></div>
            <div class="card-body">
                <p v-if="typeof errors === 'string'" class="card-text">{{errors}}</p>
                <p v-else class="card-text" v-for="(error, key) in errors" :key="key">
                    {{key}}: {{error}}
                </p>
            </div>
        </div>
        <br/>

        <div class="form-group">
            <label class="mb-1">Name:</label>
            <input v-model="pmtaConfig.name" type="text" class="form-control">
            <div v-if="$v.pmtaConfig.name.$error">
                <div class="text-danger" v-if="!$v.pmtaConfig.name.required">Name is required.</div>
            </div>
        </div>
        <div class="mb-5">
            <label>Type:</label>
            <treeselect placeholder="Select Type"
                        v-model="pmtaConfig.type"
                        :multiple="false"
                        :options="configTypeList"
                        :load-options="loadConfigTypeList"
                        value-format="object"
            />
            <div v-if="$v.pmtaConfig.type.$error">
                <div class="text-danger" v-if="!$v.pmtaConfig.type.required">Type is required.</div>
            </div>
        </div>
        <div class="form-group text-left">
            <label for="configFile">{{ this.id ? 'Attach a new file if you want to replace the config file.' : 'Attach Config File.'}}</label>
            <input @change="attach()"  type="file" id="configFile" class="w-100"/>
            <div v-if="$v.configFile.$error">
                <div class="text-danger" v-if="!$v.configFile.minLength">File is required.</div>
            </div>
        </div>
        <div class="form-group text-center p-t-5 p-b-20">
            <div class="col-xs-12">
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light" v-show="!submitting">
                    Save
                </button>
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light" disabled
                        v-show="submitting">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Submitting...
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import {required} from 'vuelidate/lib/validators';
    import PmtaConfigService from '../../services/PmtaConfigService';
    import Treeselect from '@riophae/vue-treeselect';
    import minLength from "vuelidate/src/validators/minLength";

    export default {
        name: 'PmtaConfigForm',
        props: ['id'],
        components: {Treeselect},
        data() {
            return {
                pmtaConfig: {
                    id: null,
                    type: null,
                    name: null,
                },
                configFile: [],
                errors: {},
                showFailureMessage: false,
                configTypeList: null,
                submitting: false,
            }
        },
        mounted() {
            if (this.id) {
                PmtaConfigService.getPmtaConfig(this.id).then(response => {
                    this.pmtaConfig = response.data;
                    this.pmtaConfig.type = {'id': this.pmtaConfig.type};
                    this.$emit('hidePreloader', false)
                });
            }
        },
        validations: {
            pmtaConfig: {
                name: {required},
                type: {required}
            },
            configFile:  {minLength:  minLength(1)}
        },
        methods: {
            attach() {
                this.configFile = [document.getElementById('configFile').files[0]];
            },
            onSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid) return;

                let configClone = Object.assign({}, this.pmtaConfig);
                configClone.type = configClone.type.id;

                let data = new FormData();
                data.append('configFile', document.getElementById('configFile').files[0]);
                data.append('prePmtaConfig', JSON.stringify(configClone));

                this.submitting = true;
                let submitMethod = null;
                if (this.id) {
                    submitMethod = PmtaConfigService.updatePmtaConfig(this.id, data);
                } else {
                    submitMethod = PmtaConfigService.createPmtaConfig(data);
                }

                submitMethod.then(response => {
                    if ([200, 201].includes(response.status)) {
                        this.$router.push({name: 'pmtaConfigs'});
                    }
                    this.submitting = false;
                    this.errors = response.data.error !== undefined ? response.data.error : 'Some error occurred.';
                    this.showFailureMessage = true;
                }).catch(error => {
                    this.submitting = false;
                    this.errors = error.response.data.error;
                    this.showFailureMessage = true;
                });
            },
            loadConfigTypeList({callback}) {
                PmtaConfigService.getTypeList().then(response => {
                    this.configTypeList = response.data.types.map((type, index) => {
                        return {id: index, label: type}
                    });
                    callback();
                });
            },
        }
    }
</script>

<style scoped>

</style>
